import { SuperAdminConstants } from '../../../_constants';

const initialState = { getAnalyticsOrgBatchesLoading: true, data: '', error: false };

export function getAnalyticsOrgBatchesReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_ANALYTICS_ORG_BATCHES:
            return {
                getAnalyticsOrgBatchesLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_ANALYTICS_ORG_BATCHES:
            return {
                getAnalyticsOrgBatchesLoading: false,
                data: action.getAnalyticsOrgBatches,
                error: false
            };
        case SuperAdminConstants.ANALYTICS_ORG_BATCHES_ERROR:
            return {
                getAnalyticsOrgBatchesLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageBatches/getAnalyticsOrgBatches.reducer.js